// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"34057bba","96":"f968592a","150":"54dcb55a","206":"98dd234d","258":"f38af587","322":"9e483c27","370":"b48fc881","474":"05ec78e9","604":"7fc22ad9","612":"dc2d48a6","654":"bd34d918","791":"ece877f9","931":"4962052e","980":"37d39aeb"}[chunkId] + ".chunk.css";
};